<template>
  <div class="my-order" ref="container">
  
 
	  
	  	   <!-- 顶部固定区域 -->
    <div class="top-sticky">
    <div class="header bg-color-red">
	 
      <div class="picTxt acea-row row-between-wrapper">
	  
        <div class="text">
          <div class="name">店面采购订单</div>
          <div>
            总订单：{{ orderData.allcount || 0 }}  
          </div>
		    
        </div>
        
      </div>
    </div>
    <div class="nav acea-row row-around">
	 <div
        class="item"
        :class="{ on: type === 1 }"
        @click="changetab(1)"
      >
        <div>未审核</div>
        <div class="num">{{ orderData.weishenhecount || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 2 }"
        @click="changetab(2)"
      >
        <div>待入库</div>
        <div class="num">{{ orderData.yishenhecount || 0 }}</div>
      </div>
      
   <div
        class="item"
        :class="{ on: type === 3 }"
        @click="changetab(3)"
      >
        <div>已完成</div>
        <div class="num">{{ orderData.wanchengcount || 0 }}</div>
      </div>
      
       </div>
    </div>
	<div class="scroll-container"  ref="container" @scroll="handleScroll">
    <div class="list " v-if="orderList.length>0" style="margin-bottom:50px">
      <div class="item" v-for="(order,index) in orderList" :key="order.id" @click="$router.push({ path: '/order/orderzhipeidetail/' + order.id})">
        <div class="title acea-row row-between-wrapper"   >
          <div class="acea-row row-middle">
            <span
              class="sign cart-color acea-row row-center-wrapper"
              
              >{{ index+1 }}</span
            > 
            单号:{{ order.danhao }}
          </div>
          <div class="font-color-red">{{ order.state_name }}</div>
        </div>
		
        <div class="title acea-row row-between-wrapper" >
		 <div class="acea-row row-middle" style="margin-left:30px">
            
            {{ order.riqi }} 
          </div>
          <div class="font-color-black">共{{ order.cpcount || 0 }}样商品 </div>
		 </div>
		
        <div class="totalPrice">
          <span class=" " >{{ order.dm_name }}   </span>
        </div>
        
		     <div class="line"   >
        <img src="@assets/images/line.jpg" style="width:98%"/>
      </div>
      </div>
	    </div>
    
    <div class="noCart" v-else>
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
	     <Loading :loaded="loaded" :loading="loading"></Loading>
		 
		 <!-- 模板中增加提示元素 -->
<div v-if="!loaded && orderList.length>0" class="load-tip">
  <span v-if="loading">加载中...</span>
     <span v-else-if="hasError" @click="retryLoad">
    {{ errorCount >= maxRetry ? '加载失败，点击重试' : '加载出错，重试中...' }}
  </span>
  <span v-else @click="getcaigouzhipeiOrderList">点击加载更多</span>
</div>
	 </div>
 
   
    
  </div>
</template>
<script>
import { getcaigouzhipeiOrderData, getcaigouzhipeiOrderList } from "@api/order";
import {
  cancelOrderHandle,huizongHandle
} from "@libs/order";
import Loading from "@components/Loading";
import { isWeixin } from "@utils";

const STATUS = [
  "未审核",
  "已审核" 

];

const NAME = "Zhipei";

export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 1,
      page: 1,
      limit: 10,
      loaded: false,
      loading: false,
	    scrollTimer: null, 
	   hasError: false,
    errorCount: 0, // 记录连续错误次数
    maxRetry: 3, // 最大重试次数
	 initialLoadDone: false, // 新增：初始加载状态标记
      maxAutoLoadTimes: 2, // 新增：最大自动加载次数
      autoLoadCount: 0, // 新增：当前自动加载计数
      orderList: [],
      pay: false,
	  id: this.$route.params.id,
      payType: ["yue", "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5",
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  components: {
    Loading
  },
  computed:{
  watch: {
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 1;
        if (this.type !== type) {
          this.changeType(type);
        }
        this.getcaigouzhipeiOrderData();
      }
    }
  }},
  methods: {
   retryLoad() {
    this.hasError = false;
    this.getcaigouzhipeiOrderList();
  },
    handleScroll() {
    if (this.scrollTimer || this.hasError) return; // 错误状态下不触发
      
      this.scrollTimer = setTimeout(() => {
        const container = this.$refs.container;
        // 精确触底判断 [4](@ref)
        if (
          container.scrollTop + container.clientHeight >=
          container.scrollHeight - 10
        ) {
          this.getcaigouzhipeiOrderList();
        }
        this.scrollTimer = null;
      }, 300); // 300ms节流间隔
    },
 
   huizong() {
	  
      huizongHandle()
        .then(() => {
          setTimeout(() => this.goBack(), 300);
        })
        .catch(() => {
          this.getDetail();
        });
    },
  changetab(type){
   if (this.type !== type) {
         this.type = type;
        this.orderList = [];
        this.page = 1;
        this.loaded = false;
        this.loading = false;
    this.hasError = false;
	 this.initialLoadDone = false; // 重置初始加载状态
        this.autoLoadCount = 0; // 重置自动加载计数
		 this.errorCount = 0;
		   const container = this.$refs.container;
    if (container) container.scrollTop = 0; // 滚动复位
        this.getcaigouzhipeiOrderList();
        }
 
  
  },
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },
    getcaigouzhipeiOrderData() {
      getcaigouzhipeiOrderData().then(res => {
	  console.log(res);
        this.orderData = res;
		
      });
    },
    
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.reload();
      this.getcaigouzhipeiOrderData();
    },
    reload() {
      this.changetab(this.type);
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getcaigouzhipeiOrderList();
    },
    getcaigouzhipeiOrderList() {
	 const id = this.id;
     if (this.loading || this.loaded || this.hasError || this.errorCount >= this.maxRetry) return;
      this.loading = true;
      const { page, limit, type } = this;
	     const currentTabType = this.type; 
	    
		
		 getcaigouzhipeiOrderList({ id,page, limit, type }).then(res => {
   if(res.code == 1 && currentTabType === this.type) {
      // 保留原有数据追加逻辑
      this.orderList = [...this.orderList, ...res.data];
      this.page++;
      this.loaded = res.data.length < this.limit;
         this.errorCount = 0; // 成功时重置错误计数
    // ======== 新增关键逻辑 ========
       this.$nextTick(() => {
       const container = this.$refs.container;
         if (!container) return;
		
		  // 初始加载检查：只执行1次自动加载
              if (!this.initialLoadDone) {
                const isFull = container.scrollHeight > container.clientHeight;
                
                // 未满屏、未加载完、且自动加载次数未达上限
                if (
                  !isFull &&
                  !this.loaded &&
                  this.autoLoadCount < this.maxAutoLoadTimes
                ) {
                  this.autoLoadCount++; // 增加自动加载计数
                  this.getcaigouzhipeiOrderList(); // 加载下一页
                } else {
                  this.initialLoadDone = true; // 标记初始加载完成
                }
				 }
	    
			
			
       
      });
    }
   else{
	  this.initialLoadDone = true; // API错误时标记完成
	// CODE=0 时的处理
      this.errorCount++;
      this.hasError = true; // 标记错误状态
      
      // 超过重试次数时完全停止加载
      if (this.errorCount >= this.maxRetry) {
        this.loaded = true; 
      }
	}
    this.loading = false;
  }).catch(() => {
    this.hasError = true;
    this.loading = false;
	 this.initialLoadDone = true; // 异常时标记完成
  });
  
   
	  
	  
    
    },
    getStatus(order) {
      return order.state_name;
    },
    cancelOrder(order) {
      cancelOrderHandle(order.id)
        .then(() => {
          this.getcaigouzhipeiOrderData();
          this.orderList.splice(this.orderList.indexOf(order), 1);
        })
        .catch(() => {
          this.reload();
        });
    },
     huizongOrder() {
      huizongHandle()
        .then(() => {
		 this.getcaigouzhipeiOrderData();
        this.reload();
        })
        .catch(() => {
          this.reload();
        });
    },
    toPay() {}
  },
   mounted() {
    this.getcaigouzhipeiOrderData();
    this.getcaigouzhipeiOrderList();
   	    // 移除原$scroll方法，改用原生滚动监听
    this.$refs.container.addEventListener('scroll', this.handleScroll);
  }, beforeDestroy() {
    // 清理事件和定时器
    this.$refs.container.removeEventListener('scroll', this.handleScroll);
if (this.scrollTimer) clearTimeout(this.scrollTimer);
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
/* 布局调整 */
.my-order {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 全视口高度 */
  overflow: hidden; /* 隐藏外部滚动条 */
}
/* 新增滚动容器样式 */
.scroll-container {
  height: calc(100vh - 220px); /* 根据header高度调整 */
  position: relative;
  -webkit-overflow-scrolling: touch; /* 移动端平滑滚动 */
    overflow-y: auto; /* 确保内容可滚动 */
  /* Firefox隐藏滚动条 */
  scrollbar-width: none;
  /* IE/Edge隐藏滚动条 */
  -ms-overflow-style: none;
}
/* Chrome/Safari/Opera隐藏滚动条 */
.scroll-container::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
/* 底部加载提示 */
.load-tip {
  text-align: center;
  padding: 10px;
  background: #f9f9f9;
}
</style>
